import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"7rem"} }, "Tìm kiếm", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_PerPageSelection = _resolveComponent("PerPageSelection")!
  const _component_KeHoachTable = _resolveComponent("KeHoachTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Danh sách ")
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.ADD,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.push('/quan-ly/ke-hoach-sua-chua/tao-moi')))
      }, null, 8, ["button-type"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_PerPageSelection, {
        "per-page": _ctx.perPage,
        "per-page-arr": _ctx.perPageArr,
        onChange: _cache[2] || (_cache[2] = (value) => _ctx.perPage = value)
      }, {
        other: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchTerm,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              style: {"width":"20rem"},
              placeholder: "tìm kế hoạch",
              onInput: _ctx.searchKeHoach
            }, null, 8, ["modelValue", "onInput"])
          ])
        ]),
        _: 1
      }, 8, ["per-page", "per-page-arr"]),
      _createVNode(_component_KeHoachTable, { items: _ctx.keHoachItems }, null, 8, ["items"]),
      (_ctx.keHoachItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[3] || (_cache[3] = (value) => _ctx.currentPage = value)
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}